import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { CSSTransitionGroup } from "react-transition-group";

import MinimapPortal from "./MinimapPortal";
import Styles from "./PlayerMinimap.styles";
import theme from "../../../themes/green";
import { getFileDownloadUrl } from "../../../helpers/fileHelpers";
import { IMAGE_SIZES } from "../../../constants";
import "./style.css";

class PlayerMinimap extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mapUrl: "",
      mapHeight: 0,
      mapWidth: 0,
      isLoaded: false
    };

    this.onPortalClick = this.onPortalClick.bind(this);
  }

  componentDidMount() {
    if (!this.props.project.map) {
      return;
    }

    this.updateMap(this.props);
  }

  updateMap(target) {
    const {
      map: {
        prodImage: { downloadURL, fullPath, name }
      }
    } = target.project;

    //console.log("Poprosze o update mapy " + downloadURL);

    let image = new Image();
    image.onload = () => {
      const width = window.innerWidth * 0.25;
      const percentage = width / image.width;
      const height = image.height * percentage;
      this.setState({
        mapUrl: image.src,
        mapHeight: height,
        mapWidth: width,
        isLoaded: true
      });
    };
    if (fullPath && false) {
      const path = fullPath.substring(0, fullPath.lastIndexOf("/"));

      getFileDownloadUrl(`${path}/${IMAGE_SIZES.THUMB_1028}_${name}`)
        .then(res => {
          image.src = res;
        })
        .catch(() => {
          image.src = downloadURL;
        });
    } else {
      image.src = downloadURL;
    }
  }

  shouldComponentUpdate(nextProps) {
    return true;
    /*if (
      JSON.stringify(nextProps.menuBottomStyle) !=
        JSON.stringify(this.props.menuBottomStyle) ||
      JSON.stringify(nextProps.mapBottomStyle) !=
        JSON.stringify(this.props.mapBottomStyle) ||
      JSON.stringify(nextProps.match) != JSON.stringify(this.props.match) ||
      nextProps.windowWidth != this.props.windowWidth ||
      nextProps.windowHeight != this.props.windowHeight ||
      nextProps.show != this.props.show ||
      nextProps.project.createdAt !== this.props.project.createdAt ||
      nextProps.project.map !== this.props.project.map
    ) {
      console.log("apdejt komponentu", nextProps.project);
      return true;
    } else {
      return false;
    }*/
  }

  componentWillReceiveProps(props) {
    this.updateMap(props);
  }

  onPortalClick(id) {
    this.props.onPortalClick(id);
  }

  renderWidget(id, widget) {
    let {
      params: { sceneId = null }
    } =
      this.props.match || {};
    if (!sceneId) {
      sceneId = Object.keys(this.props.project.scenes)[0];
    }
    return (
      <MinimapPortal
        key={id}
        {...widget}
        color={this.props.project.hotspots_color || "#ffffff"}
        selected={widget.sceneId === sceneId}
        onClick={this.onPortalClick}
      />
    );
  }

  getSize() {
    var widthMax = 0.4;
    var heightMax = 0.6;
    var width;
    var height;
    var vertical = false;
    if (this.props.windowWidth / this.props.windowHeight < 0.7) {
      vertical = true;
      if (
        (this.props.windowWidth * 0.9) / (this.props.windowHeight * 0.6) <
        this.state.mapWidth / this.state.mapHeight
      ) {
        width = 0.9 * this.props.windowWidth;
        height = (width * this.state.mapHeight) / this.state.mapWidth;
      } else {
        height = 0.6 * this.props.windowHeight;
        width = (height * this.state.mapWidth) / this.state.mapHeight;
      }
    } else {
      if (
        (this.props.windowWidth * widthMax) /
          (this.props.windowHeight * heightMax) <
        this.state.mapWidth / this.state.mapHeight
      ) {
        width = widthMax * this.props.windowWidth;
        height = (width * this.state.mapHeight) / this.state.mapWidth;
      } else {
        height = heightMax * this.props.windowHeight;
        width = (height * this.state.mapWidth) / this.state.mapHeight;
      }
    }
    return { width, height, vertical };
  }

  render() {
    if (!this.props.project.map) {
      return null;
    }

    const {
      map: { widgets, prodImage: { downloadURL } }
    } = this.props.project;

    const size = this.getSize();
    const style = {
      backgroundColor: theme.pallete.background,
      // changed to use pure downloadURL for map to refresh when changing projects
      backgroundImage: `url(${downloadURL})`,
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      width: size.width + "px",
      height: size.height + "px",
      position: "relative"
    };
    const verticalStyle = size.vertical
      ? {
          left: (this.props.windowWidth - size.width) * 0.5 + "px",
          marginBottom: "50px",
          ...this.props.menuBottom,
          borderColor: "rgba(0, 0, 0, 0)"
        }
      : {
          ...this.props.bottomStyle,
          borderColor: "rgba(0, 0, 0, 0.5)"
        };
    return (
      <div>
        <CSSTransitionGroup
          transitionName="slide"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {this.props.show && (
            <div
              style={{
                ...Styles.container,
                ...verticalStyle
              }}
            >
              {this.state.isLoaded && (
                <div style={[style, Styles.map]}>
                  {widgets &&
                    Object.entries(widgets).map(([id, widget]) =>
                      this.renderWidget(id, widget)
                    )}
                </div>
              )}
            </div>
          )}
        </CSSTransitionGroup>
      </div>
    );
  }
}

PlayerMinimap.defaultProps = {
  show: false
};
PlayerMinimap.propTypes = {
  show: PropTypes.bool
};

export default Radium(PlayerMinimap);



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMinimap/PlayerMinimap.js